import { useEffect } from 'react';
import { useModalContext } from '../../../../contexts/ModalContext';
import SamplingVisualizer from '../../../../components/modals/SamplingVisualizer';
import AdmActionsModal from '../../../../components/modals/AdmActions';
import { ModifyPlanSettingsModalMagpie } from '../../../../components/modals/ModifyPlanSettingsMagpie';
import ConfirmationDialog from '../../../../components/modals/ConfirmationDialog';

const SiteModals = () => {
  const { closeAllModals } = useModalContext();

  useEffect(() => {
    let openModal = null;
    if ('URLSearchParams' in window) {
      // Handle automatic modal opening.
      const searchParams = new URLSearchParams(window.location.search);
      // We must have a target site_id or we can't open anything.
      openModal = searchParams.get('open');
    }

    if (!openModal) {
      closeAllModals();
    }
  }, []);

  return (
    <>
      <SamplingVisualizer />
      <AdmActionsModal />
      <ModifyPlanSettingsModalMagpie />
      <ConfirmationDialog />
    </>
  );
};

export default SiteModals;
